import getApiInstance from 'data/common/ApiCallGenerique';
import Translator from 'translator';
import { Toastr, Logger } from 'data/common';
import api from './api';
import { getSocket } from '../../common/AllSocketsMiddleware';

const apiCaller = getApiInstance();

export function getHomes() {
    return dispatch => {
        return apiCaller
            .call(api.getAllHomes())
            .then(({ data }) => {
                if (data.success) {
                    if (data.homes) {
                        dispatch({
                            type: 'FHE__SET_HOMES',
                            homes: data.homes
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                    if (data.boxes) {
                        dispatch({
                            type: 'FHE__SET_BOXES',
                            boxes: data.boxes
                        });
                    } else throw 'general.error.data_has_not_correctly_returned_by_server';
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheHomes - ', error);
                throw error;
            });
    };
}
export function getHomeDetails(homeId) {
    return dispatch => {
        return apiCaller
            .call(api.getHomeDetails(homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_HOME',
                        homeId,
                        homeDetails: data.homeDetails
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getHomeDetails - ', error);
                throw error;
            });
    };
}
export function updateHomeDetails(homeId, homeForm) {
    return dispatch => {
        return apiCaller
            .call(api.updateHomeDetails(homeId, homeForm))
            .then(({ data }) => {
                if (data.success) {
                  dispatch({
                    type: 'FHE__UPDATE_HOME',
                    homeId,
                    homeDetails: data.homeDetails
                });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setMyFHEUserDetails - ', error);
                throw error;
            });
    };
}
export function addHome(homeForm) {
    return dispatch => {
        return apiCaller
            .call(api.addHome(homeForm))
            .then(({ data }) => {
                dispatch({
                    type: 'FHE__UPDATE_HOMES',
                    homes: data.homeDetails
                });
                if (data.box) {
                    dispatch({
                        type: 'FHE__UPDATE_BOX',
                        box: data.box
                    });
                }
                if (data.homeUsers) {
                    dispatch({
                        type: 'FHE__UPDATE_HOME_USERS',
                        homeId: data.homeId,
                        homeUsers: data.user
                    });
                }
                return { homeId: data.homeId, success: data.success };
            })
            .catch(error => {
                const message = error.type ? error.type : error;
                Logger.log('dataActions: setFheAddHome - ', message);
                throw message;
            });
    };
}
export function deleteHomeUser(homeId, userId) {
    return dispatch => {
        return apiCaller
            .call(api.deleteHomeUser(homeId, userId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_HOME_USERS',
                        homeId,
                        homeUsers: data.homeUsers
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteHomeUser - ', error);
                throw error;
            });
    };
}
export function resetPassword(userId, homeId) {
    return () => {
        return apiCaller
            .call(api.resetPassword(userId, homeId))
            .then(({ data }) => {
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: resetPassword - ', error);
                throw error;
            });
    };
}
export function addHomeUser(homeId, userForm) {
    return dispatch => {
        return apiCaller
            .call(api.addHomeUser(homeId, userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_HOME_USERS',
                        homeId,
                        homeUsers: data.homeUsers
                    });
                    if (data.intermediateError) {
                        Logger.warn('dataActions: addFheCraftsman - ', data.intermediateError);
                        Toastr.warning(
                            Translator.translateWithFallback(
                                `api.message.${data.intermediateError.response ? data.intermediateError.response : data.intermediateError.message}`,
                                'api.message.default'
                            ),
                            Translator.translate('api.message.intermediate_error')
                        );
                    }
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addHomeUser - ', error);
                throw error;
            });
    };
}
export function editHomeUser(homeId, userId, userForm) {
    return dispatch => {
        return apiCaller
            .call(api.editHomeUser(homeId, userId, userForm))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_HOME_USERS',
                        homeId,
                        homeUsers: data.homeUsers
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: addHomeUser - ', error);
                throw error;
            });
    };
}

export function getHomeUsers(homeId) {
    return dispatch => {
        return apiCaller
            .call(api.getHomeUsers(homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_HOME_USERS',
                        homeId,
                        homeUsers: data.homeUsers
                    });
                } else throw 'general.error.data_has_not_correctly_returned_by_server';
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: getHomeUsers - ', error);
                throw error;
            });
    };
}

export function getHomeHistory(homeId, withActions = false) {
    return dispatch => {
        return apiCaller
            .call(api.getHomeHistory(homeId, withActions))
            .then(({ data }) => {
                if (data.success) {
                    if (data.historyActions) {
                        dispatch({
                            type: 'FHE__SET_HISTORY_ACTIONS',
                            historyActions: data.historyActions
                        });
                    }
                    return data.homeHistory;
                }
                throw 'general.error.data_has_not_correctly_returned_by_server';
            })
            .catch(error => {
                Logger.log('dataActions: getHomeHistory - ', error);
                throw error;
            });
    };
}

export function addHomeHistory(homeId, historyForm) {
    return () => {
        return apiCaller
            .call(api.addHomeHistory(homeId, historyForm))
            .then(({ data }) => {
                if (data.success) return data.homeHistory;
                else throw 'general.error.data_has_not_correctly_returned_by_server';
            })
            .catch(error => {
                Logger.log('dataActions: addFheHistory - ', error);
                throw error;
            });
    };
}

export function getJournalisation(homeId, fromDate, toDate) {
    return () => {
        return apiCaller
            .call(api.getJournalisation(homeId, fromDate, toDate))
            .then(({ data }) => {
                if (data.success) return data.homeJournalisation;
                else throw 'general.error.data_has_not_correctly_returned_by_server';
            })
            .catch(e => {
                Logger.log('dataActions: getJournalisation - ', e);
                throw e;
            });
    };
}

export function emailExists(email) {
    return () => {
        return apiCaller.call(api.emailExists(email)).catch(e => {
            Logger.log('dataActions: emailExists - ', e);
            throw e;
        });
    };
}

export function updateConsoProd(middle, homeBox, type, productModules) {
    return () => {
        return getSocket(middle)
            .updateConsoProd(homeBox, type, productModules)
            .catch(error => {
                Logger.log('dataActions: updateConsoProd - ', error);
                throw error;
            });
    };
}

export function configureTendaRouter(middleware, macAddress, boxId) {
    return dispatch => {
        return getSocket(middleware)
            .configureTendaRouter(macAddress, boxId)
            .then(() => {})
            .catch(error => {
                Logger.log('dataActions: configureTendaRouter - ', error.message);
                throw error;
            })
    }
}



// WEBPACK FOOTER //
// ./environments/fhe/data/Homes/actions.js